'use strict';

export class ImageZoomer {
	constructor() {
		const hasZoomableImages = document.querySelector('.zoomable-image');
		if (hasZoomableImages) {
			this.initZoom();
		}
	}

	initZoom() {
		const modal = document.createElement('div');
		modal.id = 'zoomModal';
		modal.style = `
			display: none;
			position: fixed;
			top: 0;
			left: 0;
			width: 100vw;
			height: 100vh;
			background: rgba(0, 0, 0, 0.85);
			justify-content: center;
			align-items: center;
			z-index: 9999;
		`;

		const img = document.createElement('img');
		img.id = 'zoomImg';
		img.style = 'max-width: 90vw; max-height: 90vh;';
		modal.appendChild(img);

		modal.addEventListener('click', () => {
			modal.style.display = 'none';
			img.src = '';
		});

		document.body.appendChild(modal);

		document.querySelectorAll('.zoomable-image').forEach(image => {
			image.style.cursor = 'zoom-in';
			image.addEventListener('click', () => {
				img.src = image.src;
				modal.style.display = 'flex';
			});
		});
	}

}
